export const Canton = Object.freeze(
    {

    //AG: { code: "AG", valeur: "Argovie" },
    //AI: { code: "AI", valeur: "Appenzell Rhodes-Intérieures" },
    //AR: { code: "AR", valeur: "Appenzell Rhodes-Extérieures" },
    //BE: { code: "BE", valeur: "Berne" },
    //BL: { code: "BL", valeur: "Bâle-Campagne" },
    //BS: { code: "BS", valeur: "Bâle-Ville" },
    //FR: { code: "FR", valeur: "Fribourg" },
    GE: { code: "GE", valeur: "Genève" },
    //GL: { code: "GL", valeur: "Glaris" },
    //GR: { code: "GR", valeur: "Grisons" },
    //JU: { code: "JU", valeur: "Jura" },
    //LU: { code: "LU", valeur: "Lucerne" },
    //NE: { code: "NE", valeur: "Neuchâtel" },
    //NW: { code: "NW", valeur: "Nidwald" },
    //OW: { code: "OW", valeur: "Obwald" },
    //SG: { code: "SG", valeur: "Saint-Gall" },
    //SH: { code: "SH", valeur: "Schaffhouse" },
    //SO: { code: "SO", valeur: "Soleure" },
    //SZ: { code: "SZ", valeur: "Schwytz" },
    //TG: { code: "TG", valeur: "Thurgovie" },
    //TI: { code: "TI", valeur: "Tessin" },
    //UR: { code: "UR", valeur: "Uri" },
    VD: { code: "VD", valeur: "Vaud" },
    //VS: { code: "VS", valeur: "Valais" },
    //ZG: { code: "ZG", valeur: "Zoug" },
    //ZH: { code: "ZH", valeur: "Zurich" },
});
